
riot.tag2('review-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#reviews"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4"> Отзыв к товару:<b> {isNew ? \'\' : item.nameProduct}</b></div>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="row">\n        <div class="col-md-2">\n          <div class="form-group">\n            <label class="control-label">Дата</label>\n            <datetime-picker class="form-control" name="date" format="YYYY.MM.DD HH:mm" value="{item.date}"></datetime-picker>\n          </div>\n        </div>\n        <div class="col-md-2">\n          <div class="form-group">\n            <label class="control-label">Оценка</label>\n            <star-rating name="mark" count="5" size="middle" value="{item.mark}"></star-rating>\n          </div>\n        </div>\n        <div class="col-md-2">\n          <div class="form-group">\n            <label class="control-label">Опыт использования</label>\n            <select class="form-control" name="useTime" value="{item.useTime}">\n              <option value="1">Менее месяца</option>\n              <option value="2">Несколько месяцев</option>\n              <option value="3">Более года</option>\n            </select>\n          </div>\n        </div>\n        <div class="col-md-3">\n          <div class="form-group">\n            <label class="control-label">Лайков</label>\n            <div class="input-group">\n              <input class="form-control" name="likes" value="{item.likes}" min="0" type="{\'number\'}"><span class="input-group-addon"><i class="fa fa-thumbs-o-up"></i></span>\n            </div>\n          </div>\n        </div>\n        <div class="col-md-3">\n          <div class="form-group">\n            <label class="control-label">Дислайков</label>\n            <div class="input-group">\n              <input class="form-control" name="dislikes" value="{item.dislikes}" min="0" type="{\'number\'}"><span class="input-group-addon"><i class="fa fa-thumbs-o-down"></i></span>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-4">\n          <div class="form-group">\n            <label class="control-label">Автор отзыва</label>\n            <div class="input-group">\n              <div class="input-group-btn"><a class="btn btn-default" if="{item.idUser}" href="#persons/{item.idUser}" target="_blank"><i class="fa fa-eye"></i></a></div>\n              <input class="form-control" name="nameUser" type="text" value="{item.nameUser}" readonly>\n              <div class="input-group-btn">\n                <div class="btn btn-default" onclick="{changePerson}"><i class="fa fa-list text-primary"></i></div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="col-md-4">\n          <div class="form-group">\n            <label class="control-label">Товар</label>\n            <div class="input-group">\n              <div class="input-group-btn"><a class="btn btn-default" if="{item.idPrice}" href="#products/{item.idPrice}" target="_blank"><i class="fa fa-eye"></i></a></div>\n              <input class="form-control" name="nameProduct" type="text" value="{item.nameProduct}" readonly>\n              <div class="input-group-btn">\n                <div class="btn btn-default" onclick="{changeProduct}"><i class="fa fa-list text-primary"></i></div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="col-md-4">\n          <div class="form-group">\n            <label class="control-label">Email</label>\n            <input class="form-control" name="contactEmail" type="text" value="{item.contactEmail}">\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <label class="control-label">Достоинства</label>\n            <textarea class="form-control" rows="5" name="merits" style="min-width: 100%; max-width: 100%;" value="{item.merits}"></textarea>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <label class="control-label">Недостатки</label>\n            <textarea class="form-control" rows="5" name="demerits" style="min-width: 100%; max-width: 100%;" value="{item.demerits}"></textarea>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <label class="control-label">Отзыв</label>\n            <textarea class="form-control" rows="5" name="comment" style="min-width: 100%; max-width: 100%;" value="{item.comment}"></textarea>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <div class="checkbox-inline">\n              <label>\n                <input name="isActive" type="checkbox" value="{parseInt(item.isActive)}">Активен\n              </label>\n            </div>\n          </div>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function(opts) {
'use strict';

var self = this;

self.item = {};
self.orders = [];

self.mixin('change');

self.submit = function (e) {
    var params = self.item;
    self.loader = true;

    API.request({
        object: 'Review',
        method: 'Save',
        data: params,
        success: function success(response) {
            self.item = response;
            if (self.isNew) riot.route('/reviews/' + self.item.id);
            popups.create({ title: 'Успех!', text: 'Изменения сохранены!', style: 'popup-success' });
            observable.trigger('reviews-reload');
        },
        complete: function complete() {
            self.loader = false;
            self.update();
        }
    });
};

self.changePerson = function () {
    modals.create('persons-list-select-modal', {
        type: 'modal-primary',
        size: 'modal-lg',
        submit: function submit() {
            var items = this.tags.catalog.tags.datatable.getSelectedRows();

            if (items.length > 0) {
                self.item.idUser = items[0].id;
                self.item.nameUser = items[0].displayName;
                self.update();
                this.modalHide();
            }
        }
    });
};

self.changeProduct = function () {
    modals.create('products-list-select-modal', {
        type: 'modal-primary',
        size: 'modal-lg',
        submit: function submit() {
            var items = this.tags.catalog.tags.datatable.getSelectedRows();

            if (items.length > 0) {
                self.item.idPrice = items[0].id;
                self.item.nameProduct = items[0].name;
                self.update();
                this.modalHide();
            }
        }
    });
};

observable.on('review-edit', function (id) {
    var params = { id: id };
    self.loader = true;
    self.isNew = false;

    API.request({
        object: 'Review',
        method: 'Info',
        data: params,
        success: function success(response, xhr) {
            self.item = response;
            self.loader = false;
            self.update();
        },
        error: function error(response) {
            self.item = {};
            self.loader = false;
            self.update();
        }
    });
});

observable.on('review-new', function () {
    self.item = {};
    self.isNew = true;
    self.update();
});

self.reload = function () {
    observable.trigger('review-edit', self.item.id);
};

self.on('mount', function () {
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/reviews/review-edit.tag